import { render, staticRenderFns } from "./QStaff.vue?vue&type=template&id=1afc2b76&scoped=true&"
import script from "./QStaff.vue?vue&type=script&lang=js&"
export * from "./QStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc2b76",
  null
  
)

export default component.exports